// ========= REFRESHED FROM 2025-11-17 (Europe/London) =========

const recurringEvents = {
  // Entertainment awards — 2026 editions (official dates)
  'bafta-film-awards': {
    categorySlug: 'bafta-film-awards',
    displayName: 'BAFTA Film Awards',
    sectionSlug: 'entertainment',
    subSectionSlug: 'awards-and-events',
    startDate: '2026-02-01', // ~3 weeks before BAFTAs (Sun 22 Feb 2026)
    endDate: '2026-03-01',
  },
  'academy-awards': {
    categorySlug: 'academy-awards',
    displayName: 'Academy Awards',
    sectionSlug: 'entertainment',
    subSectionSlug: 'awards-and-events',
    startDate: '2026-02-23', // ~3 weeks before Oscars (Sun 15 Mar 2026)
    endDate: '2026-03-19',
  },
  'brit-awards': {
    categorySlug: 'brit-awards',
    displayName: 'BRIT Awards',
    sectionSlug: 'entertainment',
    subSectionSlug: 'awards-and-events',
    startDate: '2026-02-07', // ~3 weeks before BRITs (Sat 28 Feb 2026)
    endDate: '2026-03-05',
  },

  // Football (soccer)
  'uefa-champions-league': {
    categorySlug: 'uefa-champions-league',
    displayName: 'UEFA Champions League',
    sectionSlug: 'sports',
    subSectionSlug: 'football',
    startDate: '2025-07-08', // 2025/26 season qualifying started 8 Jul 2025
    endDate: '2026-06-03',   // a few days after final on Sat 30 May 2026
  },
  'premier-league': {
    categorySlug: 'premier-league',
    displayName: 'Premier League (2025/26)',
    sectionSlug: 'sports',
    subSectionSlug: 'football',
    startDate: '2025-08-15', // season start
    endDate: '2026-05-31',   // a week after final round on Sun 24 May 2026
  },

  // Major 2026 sports added
  'winter-olympics': {
    categorySlug: 'winter-olympics',
    displayName: 'Winter Olympics (Milano Cortina 2026)',
    sectionSlug: 'sports',
    subSectionSlug: 'other-sports',
    startDate: '2026-01-16', // ~3 weeks pre Opening (Fri 6 Feb 2026)
    endDate: '2026-02-25',   // few days post Closing (Sun 22 Feb 2026)
  },
  'fifa-world-cup': {
    categorySlug: 'fifa-world-cup',
    displayName: 'FIFA World Cup 2026',
    sectionSlug: 'sports',
    subSectionSlug: 'football',
    startDate: '2026-05-21', // ~3 weeks pre kickoff (Thu 11 Jun 2026)
    endDate: '2026-07-23',   // few days after final (Sun 19 Jul 2026)
  },
  'six-nations': {
    categorySlug: 'six-nations',
    displayName: 'Six Nations 2026',
    sectionSlug: 'sports',
    subSectionSlug: 'rugby-union',
    startDate: '2026-01-15', // ~3 weeks before opening match (Thu 5 Feb 2026)
    endDate: '2026-03-18',   // few days after Super Saturday (Sat 14 Mar 2026)
  },
  'wimbledon': {
    categorySlug: 'wimbledon',
    displayName: 'Wimbledon 2026',
    sectionSlug: 'sports',
    subSectionSlug: 'tennis',
    startDate: '2026-06-08', // ramp from early June (tourney 29 Jun–12 Jul 2026)
    endDate: '2026-07-16',
  },

  // Festivals
  'glastonbury-festival': {
    categorySlug: 'glastonbury-festival',
    displayName: 'Glastonbury Festival',
    sectionSlug: 'travel-and-events',
    subSectionSlug: 'festivals',
    startDate: '2027-06-01', // 2026 is a fallow year; next festival 23–27 Jun 2027
    endDate: '2027-07-02',
  },
  'coachella-music-arts-festival': {
    categorySlug: 'coachella-music-arts-festival',
    displayName: 'Coachella Festival',
    sectionSlug: 'travel-and-events',
    subSectionSlug: 'festivals',
    startDate: '2026-03-20', // ~3 weeks before weekend one (Apr 10–12 & 17–19, 2026)
    endDate: '2026-04-24',
  },

  // Retail events — 2025 still upcoming
  'black-friday': {
    categorySlug: 'black-friday',
    displayName: 'Black Friday',
    sectionSlug: 'discover',
    subSectionSlug: '',
    startDate: '2025-11-21', // a week before Fri 28 Nov 2025
    endDate: '2025-12-02',
  },
  'cyber-monday': {
    categorySlug: 'cyber-monday',
    displayName: 'Cyber Monday',
    sectionSlug: 'discover',
    subSectionSlug: '',
    startDate: '2025-11-28', // few days before Mon 1 Dec 2025
    endDate: '2025-12-02',
  },

  // Seasonal / cultural — roll to 2026 if 2025 has passed
  christmas: {
    categorySlug: 'christmas',
    displayName: 'Christmas',
    sectionSlug: 'travel-and-events',
    subSectionSlug: 'events',
    startDate: '2025-12-01',
    endDate: '2025-12-26',
  },
  diwali: {
    categorySlug: 'diwali',
    displayName: 'Diwali',
    sectionSlug: 'travel-and-events',
    subSectionSlug: 'events',
    startDate: '2026-11-05', // Diwali day is Sun 8 Nov 2026; cover the 5-day festival
    endDate: '2026-11-10',
  },
  easter: {
    categorySlug: 'easter',
    displayName: 'Easter',
    sectionSlug: 'travel-and-events',
    subSectionSlug: 'events',
    startDate: '2026-03-23', // lead-in to Good Fri 3 Apr / Easter Sun 5 Apr 2026
    endDate: '2026-04-12',
  },
  'eid-al-fitr': {
    categorySlug: 'eid-al-fitr',
    displayName: 'Eid al-Fitr',
    sectionSlug: 'travel-and-events',
    subSectionSlug: 'events',
    startDate: '2026-03-17', // expected Eid ~19–20 Mar 2026 in UK
    endDate: '2026-03-22',
  },
  'fathers-day': {
    categorySlug: 'fathers-day',
    displayName: 'Fathers Day',
    sectionSlug: 'travel-and-events',
    subSectionSlug: 'events',
    startDate: '2026-06-14', // a week before Sun 21 Jun 2026 (UK)
    endDate: '2026-06-22',
  },
  halloween: {
    categorySlug: 'halloween',
    displayName: 'Halloween',
    sectionSlug: 'travel-and-events',
    subSectionSlug: 'events',
    startDate: '2026-10-24',
    endDate: '2026-11-01',
  },
  'mothers-day': {
    categorySlug: 'mothers-day',
    displayName: 'Mothers Day',
    sectionSlug: 'travel-and-events',
    subSectionSlug: 'events',
    startDate: '2026-03-08', // a week before UK Mothering Sunday (Sun 15 Mar 2026)
    endDate: '2026-03-16',
  },
  ramadan: {
    categorySlug: 'ramadan',
    displayName: 'Ramadan',
    sectionSlug: 'travel-and-events',
    subSectionSlug: 'events',
    startDate: '2026-02-17', // expected start evening Tue 17 Feb 2026
    endDate: '2026-03-20',   // expected end ~20 Mar (subject to moon sighting)
  },
  'st-patricks-day': {
    categorySlug: 'st-patricks-day',
    displayName: 'St Patricks Day',
    sectionSlug: 'travel-and-events',
    subSectionSlug: 'events',
    startDate: '2026-03-10',
    endDate: '2026-03-18',
  },
  'valentines-day': {
    categorySlug: 'valentines-day',
    displayName: 'Valentines Day',
    sectionSlug: 'travel-and-events',
    subSectionSlug: 'events',
    startDate: '2026-01-24', // ~3 weeks before Sat 14 Feb 2026
    endDate: '2026-02-15',
  },
};

export default {
  breadcrumbsEnabled: true,
  communicationPreferencesEnabled: false,
  domainExclusionsEnabled: false,
  features: {
    domainExclusions: '',
    siteRoot: 'https://www.mynewsassistant.com',
    trendingKeywords: {
      'deals': {
        categorySlug: 'deals-and-reviews',
        displayName: 'Deals And Reviews',
        sectionSlug: 'life-and-style',
        subSectionSlug: '',
      },
      'king-charles': {
        categorySlug: 'king-charles',
        categoryQuery: '',
        displayName: 'King Charles',
        domains: '',
        excludeQuery: '',
        name: 'king-charles',
        orSearchQuery: '',
        searchQuery: 'king charles',
        sectionSlug: 'feed',
        sortOrder: 'date',
        subSectionSlug: '',
      },
      'keir-starmer': {
        categorySlug: 'keir-starmer',
        categoryQuery: '',
        displayName: 'Keir Starmer',
        domains: '',
        excludeQuery: '',
        name: 'keir-starmer',
        orSearchQuery: '',
        searchQuery: 'Keir Starmer',
        sectionSlug: 'feed',
        sortOrder: 'date',
        subSectionSlug: '',
      },
      'donald-trump': {
        categorySlug: 'donald-trump',
        categoryQuery: '',
        displayName: 'Donald Trump',
        domains: '',
        excludeQuery: '',
        name: 'donald-trump',
        orSearchQuery: '',
        searchQuery: 'Donald Trump',
        sectionSlug: 'feed',
        sortOrder: 'date',
        subSectionSlug: '',
      },
      inflation: {
        categorySlug: 'inflation',
        categoryQuery: '',
        displayName: 'Inflation',
        domains: '',
        excludeQuery: '',
        name: 'inflation',
        orSearchQuery: '',
        searchQuery: 'Inflation',
        sectionSlug: 'feed',
        sortOrder: 'date',
        subSectionSlug: '',
      },
      'royal-family': {
        categorySlug: 'royal-family',
        categoryQuery: '',
        displayName: 'Royal Family',
        domains: '',
        excludeQuery: '',
        name: 'royal-family',
        orSearchQuery: '',
        searchQuery: 'Royal Family',
        sectionSlug: 'feed',
        sortOrder: 'date',
        subSectionSlug: '',
      },
      ...recurringEvents
    },
    CustomSuggestedCategories: {
      'royal-family': {
        'king-charles': {
          categorySlug: 'king-charles',
          categoryQuery: '',
          displayName: 'King Charles',
          domains: '',
          excludeQuery: '',
          name: 'king-charles',
          orSearchQuery: '',
          searchQuery: 'king charles',
          sectionSlug: 'feed',
          sortOrder: 'date',
          subSectionSlug: '',
        },
        'queen-camilla': {
          categorySlug: 'queen-camilla',
          categoryQuery: '',
          displayName: 'Queen Camilla',
          domains: '',
          excludeQuery: '',
          name: 'queen-camilla',
          orSearchQuery: '',
          searchQuery: 'queen camilla',
          sectionSlug: 'feed',
          sortOrder: 'date',
          subSectionSlug: '',
        },
        'prince-william': {
          categorySlug: 'prince-william',
          categoryQuery: '',
          displayName: 'Prince of Wales',
          domains: '',
          excludeQuery: '',
          name: 'prince-william',
          orSearchQuery: '',
          searchQuery: 'prince william',
          sectionSlug: 'feed',
          sortOrder: 'date',
          subSectionSlug: '',
        },
        'princess-of-wales': {
          categorySlug: 'princess-of-wales',
          categoryQuery: '',
          displayName: 'Princess of Wales',
          domains: '',
          excludeQuery: '',
          name: 'princess-of-wales',
          orSearchQuery: '',
          searchQuery: 'princess of wales',
          sectionSlug: 'feed',
          sortOrder: 'date',
          subSectionSlug: '',
        },
        'prince-harry': {
          categorySlug: 'prince-harry',
          categoryQuery: '',
          displayName: 'Prince Harry',
          domains: '',
          excludeQuery: '',
          name: 'prince-harry',
          orSearchQuery: '',
          searchQuery: 'prince harry',
          sectionSlug: 'feed',
          sortOrder: 'date',
          subSectionSlug: '',
        },
        'duchess-of-sussex': {
          categorySlug: 'duchess-of-sussex',
          categoryQuery: '',
          displayName: 'Duchess of Sussex',
          domains: '',
          excludeQuery: '',
          name: 'duchess-of-sussex',
          orSearchQuery: '',
          searchQuery: 'duchess of sussex',
          sectionSlug: 'feed',
          sortOrder: 'date',
          subSectionSlug: '',
        },
      },
    },
  },
  iframeCategory: false,
  iframeHome: false,
  mantisIdEnabled: true,
  ppidEnabled: true,
  SpeechBubbleEnabled: false,
  TrendingComponentEnabled: true,
  UserDefinedCategoriesEnabled: true,
};
